import axios from '../axios/axios-auth'

export default class ReportsService {

    getReportV2(chassis, start, end) {
        return axios.get('/events/v1/eventsData/vehicles/' + chassis + '/date/' + start + '/' + end).then(response => response.data)
    }

    getReportV2Anomalias(chassis, start, end) {
        return axios.get('/events/v1/eventsData/vehicles/' + chassis + '/date/' + start + '/' + end).then(response => response.data)
    }

    getConnectivityEvents(params) {
        return axios.get('/events/v1/connectivityEvents', {params: params}).then(response => response.data)
    }

}
